import cn from 'classnames'
import styles from './ConnectMetamask.module.sass'
import React, { useContext } from 'react'
import SwitchToMetamaskBrowser from './SwitchToMetamaskBrowser'
import Modal from '../Modal'
import SwitchNetwork from './SwitchNetwork'
import { isMobile } from 'react-device-detect'
import { useStateIfMounted } from 'use-state-if-mounted'
import { Web3Context } from '../../contexts/Web3Context'

const ConnectMetamask = ({ longTxt = false, className = 'button-stroke button-small' }) => {
  const [showSwitch, setShowSwitch] = useStateIfMounted(false)
  const [showSwitchMetamask, setShowSwitchMetamask] = useStateIfMounted(false)

  const { isConnected, isCorrectNetwork, connectWeb3, disconnect } = useContext(Web3Context)

  const connectMM = async (event) => {
    event.stopPropagation()
    event.nativeEvent.stopImmediatePropagation()

    try {
      if (isMobile && !window.ethereum) {
        return setShowSwitchMetamask(true)
      }
      let conn = isConnected
      if (!isConnected) {
        conn = await connectWeb3()
      }

      if (conn && !isCorrectNetwork) setShowSwitch(true)
    } catch (e) {
      return false
    }
  }

  return (
    <>
      {!(isConnected && isCorrectNetwork) && <button onClick={connectMM} className={cn(styles.btn, 'button button-small', className)}>
        {/*Connect Wallet*/}
        {!longTxt && 'Connect Wallet'}
        {longTxt && 'Login with MetaMask wallet'}
        {/*<img src="/images/content/wallet.svg" alt="" className=""/>*/}
      </button>}

      {isConnected && isCorrectNetwork &&
        <button className={className} onClick={disconnect}
                type="button">
          Disconnect
        </button>}

      {isConnected && !isCorrectNetwork &&
        <Modal visible={showSwitch} onClose={() => setShowSwitch(false)} onClickOutside={() => {
          setShowSwitch(false)
        }}>
          <SwitchNetwork/>
        </Modal>
      }

      <Modal visible={showSwitchMetamask} onClose={() => setShowSwitchMetamask(false)} onClickOutside={() => {
        setShowSwitchMetamask(false)
      }}>
        <SwitchToMetamaskBrowser/>
      </Modal>

    </>
  )
}

export default ConnectMetamask
